// src/pages/Tools/components/ToolFeatureCard.tsx
// Replaces: .feature-card-tool, .use-case-item-tool, .faq-item-tool
//           and the svg/h3/p styles inside each

import React from 'react';
import { cn } from '../../../lib/utils';

interface ToolFeatureCardProps {
    children: React.ReactNode;
    /**
     * default → white bg (features, use-cases)
     * faq     → #f8f9fa bg, text-left (faq items)
     */
    variant?: 'default' | 'faq';
    className?: string;
}

/*
 * .feature-card-tool / .use-case-item-tool:
 *   padding: 24px; background: white; border: 1px solid #dadce0;
 *   border-radius: 12px; box-shadow: sm shadow;
 *
 * .faq-item-tool:
 *   same base but background: #f8f9fa; text-align: left;
 *   h3: font-size: 1rem (instead of 1.125rem)
 *   p: font-size: 0.9375rem; line-height: 1.7;
 *
 * svg inside feature-card-tool: color: #1a73e8; margin-bottom: 16px;
 * h3 inside: font-size: 1.125rem; font-weight: 500; color: #202124; margin: 0 0 12px;
 * p  inside: font-size: 0.875rem; color: #5f6368; margin: 0; line-height: 1.6;
 */
const ToolFeatureCard: React.FC<ToolFeatureCardProps> = ({
    children,
    variant = 'default',
    className,
}) => (
    <div className={cn(
        'p-[24px] border border-[#dadce0] rounded-[12px]',
        'shadow-[0_1px_2px_0_rgba(60,64,67,0.3),0_1px_3px_1px_rgba(60,64,67,0.15)]',
        variant === 'faq'
            ? [
                'bg-[#f8f9fa] text-left',
                '[&_h3]:text-[1rem] [&_h3]:font-medium [&_h3]:text-[#202124] [&_h3]:m-0 [&_h3]:mb-[12px]',
                '[&_p]:text-[0.9375rem] [&_p]:text-[#5f6368] [&_p]:m-0 [&_p]:leading-[1.7]',
            ]
            : [
                'bg-white',
                '[&_svg]:text-[#1a73e8] [&_svg]:mb-[16px]',
                '[&_h3]:text-[1.125rem] [&_h3]:font-medium [&_h3]:text-[#202124] [&_h3]:m-0 [&_h3]:mb-[12px]',
                '[&_p]:text-[0.875rem] [&_p]:text-[#5f6368] [&_p]:m-0 [&_p]:leading-[1.6]',
            ],
        className,
    )}>
        {children}
    </div>
);

export default ToolFeatureCard;
